import numeral from 'numeral';
import { Cell } from '@table-library/react-table-library/table';
import { Fragment } from 'react';
import Sparkline from '../../../../../components/Sparklines';
import { showDifficulty, showIntent, showSerpFeatures } from '../../../../../helpers/commerce';

function createLink(path) {
    const url = new URL(window.location);
    const intent = url.searchParams.get('intent');

    if (intent) path += `&intent=${intent}`;
    return path;
}

export const COLUMNS = (t, project_id, own_domain) => [
    {
        label: t('commerce.detail.keywords.columns.keyword'),
        key: 'keyword',
        data: 'keyword',
        sortType: 'string',
        Component: Cell,
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;

            return (
                <strong className="wripe">
                    <a
                        href={createLink(
                            `/commerce/${project_id}/keyword/${encodeURIComponent(
                                data,
                            )}?own_domain=${own_domain}`,
                        )}
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: item.position ? 'green' : 'red' }}
                    >
                        <span>{data}</span> <span style={{ fontSize: '30px' }}>→</span>
                    </a>
                </strong>
            );
        },
    },
    {
        label: t('commerce.detail.keywords.columns.searchVolume'),
        key: 'search_volume',
        data: 'search_volume',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('commerce.detail.keywords.columns.ownRanking'),
        key: 'position',
        data: 'position',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('commerce.detail.keywords.columns.ownUrls'),
        key: 'own_urls',
        data: 'own_urls',
        Component: Cell,
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? data : <strong>{numeral(data).format('0.0a')}</strong>,
    },
    {
        label: t('commerce.detail.keywords.columns.cpc'),
        key: 'cpc',
        data: 'cpc',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => (csvDownload ? data : <strong>${data}</strong>),
    },
    {
        label: t('commerce.detail.keywords.columns.serpFeatures'),
        key: 'keywords_serp_features',
        data: 'keywords_serp_features',
        Component: Cell,
        cellSize: 'minmax(180px, 2fr)',
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? (
                data
            ) : (
                <div className="d-flex align-center">{showSerpFeatures(data)}</div>
            ),
    },
    {
        label: t('commerce.detail.keywords.columns.keywordDifficulty'),
        key: 'keyword_difficulty_index',
        data: 'keyword_difficulty_index',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            const dot = showDifficulty(data);
            return (
                <div className="d-flex align-items-center">
                    <strong>{data}</strong>
                    {dot}
                </div>
            );
        },
    },
    {
        label: t('commerce.detail.keywords.columns.monthlyTrends'),
        key: 'trends',
        data: 'trends',
        Component: Cell,
        cellSize: 'minmax(180px, 1.5fr)',
        renderCell: ({ data, csvDownload }) =>
            csvDownload ? (
                data
            ) : (
                <Sparkline
                    dataL={data?.split(',')?.map((item) => Number(item))}
                    keyName="Trends"
                    dontShowLable
                />
            ),
    },
    {
        label: t('commerce.detail.keywords.columns.intent'),
        key: 'intent',
        data: 'intent',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <div className="d-flex align-center">
                    {showIntent(data)?.map((item, i) => (
                        <Fragment key={i}>{item}</Fragment>
                    ))}
                </div>
            );
        },
    },
];
